import type { RoomMaterials, InteriorMaterial } from "building-types/materials/interiorPaletteTypes";
import type { MaterialSettingsBase, TableOfMaterialSlotTables } from "./materialSettingsBase";
import type { SettingsType } from "./settingsType";

export const interiorMaterialSlotNames: (keyof RoomMaterials)[] = [
  "floorInterior0",
  "floorInterior1",
  "floorInterior2",
  "floorInterior3",
  "floorInterior4",
  "floorInterior5",

  "wallInterior0",
  "wallInterior1",
  "wallInterior2",

  "trimInterior0",
  "trimInterior1",
  "trimInterior2",

  "ceiling0",
  "ceiling1",
  "ceiling2",

  "glass0",
  "glass1",
  "glass2",

  "doorInterior0",
  "doorInterior1",
  "doorInterior2",

  "doorFixture0",
  "doorFixture1",
  "doorFixture2",

  "propDefault0",
  "propDefault1",
  "propDefault2",
];

export const interiorMaterialChoices: InteriorMaterial[] = [...interiorMaterialSlotNames];

export interface InteriorMaterialSettings extends MaterialSettingsBase {
  readonly type: SettingsType.INTERIOR_MATERIAL_SETTINGS;
  readonly paletteSlotsUserDefinedNames?: TableOfMaterialSlotTables;
}

export const interiorCeilingMaterialChoices: InteriorMaterial[] = [
  "ceiling0",
  "ceiling1",
  "ceiling2",
  "floorInterior0",
  "floorInterior1",
  "floorInterior2",
  "floorInterior3",
  "wallInterior0",
  "wallInterior1",
  "wallInterior2",
  "trimInterior0",
  "trimInterior1",
  "trimInterior2",
];

export const interiorWallMaterialChoices: InteriorMaterial[] = ["wallInterior0", "wallInterior1", "wallInterior2"];

export const interiorDoorCasingMaterialChoices: InteriorMaterial[] = [
  "trimInterior0",
  "trimInterior1",
  "trimInterior2",
];

export const interiorBaseBoardMaterialChoices: InteriorMaterial[] = ["trimInterior0", "trimInterior1", "trimInterior2"];

export const interiorCrownMoldingMaterialChoices: InteriorMaterial[] = [
  "trimInterior0",
  "trimInterior1",
  "trimInterior2",
];
